import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M27.174 5.325a2.777 2.777 0 00-2.845-.685L5.903 10.79a2.794 2.794 0 00-1.8 3.398c.128.456.37.872.703 1.209l4.336 4.299a.445.445 0 01.12.308l-.12 5.395a.822.822 0 00.394.736.858.858 0 00.857 0l3.172-1.712a.412.412 0 01.497.085l3.068 3.066a2.863 2.863 0 001.937.908c.21.026.423.026.634 0a2.743 2.743 0 002.005-1.833l6.154-18.48a2.773 2.773 0 00-.686-2.843zm-4.525 5.806l-9.05 9.865a.585.585 0 01-.429.189.6.6 0 01-.6-.6v-3.63a1.712 1.712 0 01.755-1.422l8.347-5.55a.772.772 0 01.789 0 .737.737 0 01.394.669.754.754 0 01-.206.48z",
      fill: "#fff"
    }
  )
), t = e;
export {
  t as default
};
